// extracted by mini-css-extract-plugin
export default {"admin_wp":"Admin_admin_wp__OjAGC","flex_course":"Admin_flex_course__EDwRn"};